<script setup>
import { computed } from 'vue';
import { usePage } from '@inertiajs/vue3';

const errors = computed(() => usePage().props.errors);
const hasErrors = computed(() => Object.keys(errors.value).length > 0);
</script>

<template>
    <div v-if="hasErrors" class="bg-[#A71B1B] rounded-lg p-5">
        <div class="font-medium text-white">
            {{ $t('application.general.error') }}
        </div>

        <ul class="mt-3 text-sm text-white list-disc list-inside">
            <li v-for="(error, key) in errors" :key="key">
                {{ error }}
            </li>
        </ul>
    </div>
</template>
